/**
 * @file The purchase album faces component.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import PurchaseAlbumHeaderContainer from '../../containers/purchase/PurchaseAlbumHeaderContainer';
import ContentWrap from '../global/ContentWrap';
import ContentHeader from '../global/ContentHeader';
import SelectAccountIdentitiesContainer from '../../containers/purchase/SelectAccountIdentitiesContainer';
import Button from '../global/Button';
import { getAccountCheckoutGreetingName } from '../../util/account';
import ContextualString from '../contextual/ContextualString';
import { shouldDisplayBrandAttribution } from '../../util/ppd-purchase';
import PhotographerAttributionBanner from '../discover/PhotographerAttributionBanner';

class PurchaseAlbumFaces extends Component {
  static propTypes = {
    album: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      display_name: PropTypes.string,
    }),
    selectedIdentitiesForPurchase: PropTypes.arrayOf(PropTypes.object),
    selectedIdentitiesForJoin: PropTypes.arrayOf(PropTypes.object),
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    location: PropTypes.shape({
      state: PropTypes.shape({
        fromUpsell: PropTypes.bool,
      }),
    }),
  };

  onGoToCheckout = () => {
    const { album, history } = this.props;
    history.push(`/purchase/album/${album.id}/checkout`);
  };

  render() {
    const {
      album,
      selectedIdentitiesForPurchase,
      selectedIdentitiesForJoin,
      location,
    } = this.props;

    const fromUpsell = location.state && location.state.fromUpsell;

    return (
      <div className="wrapper-main content-wrap-gray">
        <PurchaseAlbumHeaderContainer album={album} />

        {shouldDisplayBrandAttribution(album) && (
          <PhotographerAttributionBanner account={album.creator} />
        )}

        <ContentWrap>
          {fromUpsell ? (
            <ContentHeader title="Confirm the faces for this subscription" />
          ) : (
            <ContentHeader title="Who should I look for?" />
          )}

          {!fromUpsell && (
            <ContextualString
              id="checkoutIdentitySelectionMessage"
              type={get(album, 'album_type')}
              subtype={get(album, 'album_subtype')}
              defaultMessage="Select an identity below so I know who to find."
              values={{
                entityName: getAccountCheckoutGreetingName(
                  get(album, 'creator'),
                ),
              }}
            />
          )}

          <SelectAccountIdentitiesContainer album={album} />

          <Button
            disabled={
              [...selectedIdentitiesForPurchase, ...selectedIdentitiesForJoin]
                .length === 0
            }
            onClick={this.onGoToCheckout}
            btnBlock
            className="mt-5"
          >
            Continue
          </Button>
        </ContentWrap>
      </div>
    );
  }
}

export default PurchaseAlbumFaces;
